import { User } from '@/types';
import { readQuery } from '@/utils';

export function setBrandPrimaryColorByQuery() {
  const bgcKey = 'x-bgc';
  const bgc = readQuery('bgc');

  const _bgc = bgc ?? localStorage.getItem(bgcKey);
  if (_bgc) {
    const color = `#${_bgc}`;
    const isHex = /^#[0-9A-F]{6}[0-9a-f]{0,2}$/i.test(color);
    if (!isHex) {
      return;
    }

    let style = document.createElement('style');
    style.innerHTML = `
        .custom-bgc {
          --brand-primary-color: ${color};
        }
      `;
    document.head.appendChild(style);
    localStorage.setItem(bgcKey, _bgc);
    document.body.classList.add('custom-bgc');
  }
}

export function setThemeColorByCategory(value: User.UserCategory.Category) {
  const FP_COLOR = '#5e06b6';
  const FPxMC_COLOR = '#141413';

  document.body.classList.add(`user-category--${value}`);
  document
    .querySelector('meta[name="theme-color"]')
    ?.setAttribute(
      'content',
      value === User.UserCategory.Category.Individual ? FP_COLOR : FPxMC_COLOR,
    );
}
